import { render, staticRenderFns } from "./CockpitPersonSelect.vue?vue&type=template&id=f3b9dce6&scoped=true"
import script from "./CockpitPersonSelect.vue?vue&type=script&lang=js"
export * from "./CockpitPersonSelect.vue?vue&type=script&lang=js"
import style0 from "./CockpitPersonSelect.vue?vue&type=style&index=0&id=f3b9dce6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b9dce6",
  null
  
)

export default component.exports